import React from "react";
import PropTypes from "prop-types";
import styles from "./StatsPieChart.module.css";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const DEFAULT_COLORS = ["#91B6BB", "#415364", "#74531B", "#B16D03"];

export function StatsPieChart({ data, colors }) {
  const total = React.useMemo(() => {
    const sum = data.reduce((acc, item) => acc + (Number(item.value) || 0), 0);

    return sum.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }, [data]);

  const palette =
    colors && colors.length
      ? colors
      : data.some((d) => d.color)
      ? data.map((d) => d.color)
      : DEFAULT_COLORS;

  return (
    <div className={styles.card}>
      <div className={styles.chartWrapper}>
        <div className={styles.chartInner}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="label"
                innerRadius="60%"
                outerRadius="90%"
                paddingAngle={2}
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`slice-${entry.label}-${index}`}
                    fill={palette[index % palette.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.centerLabel}>{total}</div>
        </div>
      </div>

      <div className={styles.legend}>
        {data.map((item, index) => (
          <div key={item.label} className={styles.legendRow}>
            <div className={styles.legendLeft}>
              <span
                className={styles.colorBox}
                style={{
                  backgroundColor: palette[index % palette.length],
                }}
              />
              <span className={styles.label}>{item.label}</span>
            </div>
            <div className={styles.amount}>
              {Number(item.value || 0).toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

StatsPieChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string),
};
